<template>
<div class='text-left ma-3'
>
  <div class='ma-1 mb-6'>
  <v-btn to='/' icon class='mt-4'><v-icon>mdi-arrow-left</v-icon></v-btn>
  <h1 style='font-size: 56px;' class='mt-4'>{{ gallery.title }}</h1>
  <h4 class='ml-1'>THON {{ thon_year }} / {{ new Date(gallery.date).toLocaleString('en-US', {month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC'}) }}</h4> 
  </div>
  <v-dialog
      v-model="dialog"
      fullscreen
    >
      <v-card
      color="thon-blue"
      class="rounded-0">      <!--color="rgba(0, 0, 0, 0.75)"-->
        <v-img :lazy-src="selectedPhoto.url_thumbnail" :src="selectedPhoto.url_resized" height="100%" contain></v-img>
        <v-btn icon  large style="top: 0;
        right: 0;
    position: absolute;
    margin: 10px 10px 0 0 ;"
    @click="closeDialog()" dark><v-icon>mdi-close</v-icon></v-btn>
    <v-btn style="bottom: 0;
        right: 0;
    position: absolute;
    margin: 0 10px 10px 0;" color="thon-gold" rounded
    v-if="selectedPhoto.photographer"
    :to="'/photographer/' + selectedPhoto.photographer.slug">
    <v-icon left>mdi-account</v-icon>
    {{ selectedPhoto.photographer.first_name + ' ' + selectedPhoto.photographer.last_name }}
  </v-btn>

<v-sheet style='bottom: 0;
        left: 0;
    position: absolute;
    margin: 0 0 10px 10px;'
    elevation="2"
    dark
    class="pa-1 rounded-pill">
  <!--<v-menu
      :nudge-width="200"
      offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-information</v-icon>
        </v-btn>
      </template>
      <v-list dense class="text-left">
        <v-list-item>
          <v-list-item-content>
          <v-list-item-title>Capture Date</v-list-item-title>
          <v-list-item-subtitle>{{ new Date(selectedPhoto.captured_at).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric'}) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
          <v-list-item-title>{{ selectedPhoto.photographer }} {{ selectedPhoto.photographer }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
  </v-menu>-->
  <!--<v-btn icon dark ><v-icon>mdi-link</v-icon></v-btn>-->
  <v-btn icon dark :href="selectedPhoto.url_original" target="_blank"><v-icon>mdi-download</v-icon></v-btn>
  <v-btn icon dark @click="previousPhoto()"><v-icon>mdi-chevron-left</v-icon></v-btn>
  <v-btn icon dark @click="nextPhoto()"><v-icon>mdi-chevron-right</v-icon></v-btn>
</v-sheet>
      </v-card>
    </v-dialog>
  <div>
    <div v-for='row in galleryRows' :key='row.id'>
        <img
          v-for='photo in row.photos'
          :key='photo.id'
          :src="photo.url_resized"
          :style="'object-fit: cover; background-color: #f7f7f7;' + (photoWidthRatio(photo) == 1 ? 'aspect-ratio: 2 / 3;' : 'aspect-ratio: 3 / 2;')"
          :class="[photoWidthRatio(photo) == 1 ? row.classPortrait : row.classLandscape]"
          @click="openDialog(photo)"
          loading="lazy"
        />
    </div>
  </div>
  <div id="galleryEnd"></div>
  <v-btn style="bottom: 0;
    position: fixed;
    left: 50%;
    margin-left: -35px;
    margin-bottom: 10px; z-index: 100;" color="thon-gold" rounded
    v-if="pagesLoaded < gallery.page_count">
    <div v-if="$store.state.loading">
      <v-progress-circular indeterminate size="15" width="2"></v-progress-circular>
    </div>
    <div v-else>
      <v-icon>mdi-chevron-down</v-icon>
    </div>
  </v-btn>
</div>
</template>

<script>
export default {
    name: 'gallery',
    props:['thon_year', 'slug'],
    data() {
      return {
        gallery: {},
        photos: [],
        selectedPhoto: 0,
        pagesLoaded: 0,
        dialog: false,
      }
    },
    components: {
    },
    computed: {
    galleryRows () {
      let rows = []
      let temp_photos = JSON.parse(JSON.stringify(this.photos));
      //temp_photos = temp_photos.reverse();
      while (temp_photos.length > 0) {
        let row_p = 0
        let row_l = 0
        let row_size = 0
        let row = []
        //let to_next_row = []
        let max_row_size = 0;
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          max_row_size = 4
          break
          case 'sm':
          max_row_size = 5.25
          break
          case 'md':
          max_row_size = 6
          break
          case 'lg':
          max_row_size = 8
          break
          case 'xl':
          max_row_size = 11.25
          break
        }
        while (row_size < max_row_size - 1.25 && temp_photos.length > 0) {
          let photo = temp_photos.pop(0)
          if (this.photoWidthRatio(photo) == 1) {
              row_p += 1
              row_size += 1
            } else if (this.photoWidthRatio(photo) == 2.25) {
              row_l += 1
              row_size += 2.25
            }
          row.push(photo)
          /*let photo = temp_photos.pop(0)
          if (row_size + photo <= max_row_size) {
            if (photo == 1) {
                row_p += 1
              row_size += 1
            } else if (photo == 2.25) {
              row_l += 1
              row_size += 2.25
            }
            row.push(photo)
          } else {
              to_next_row.push(photo)
          }*/
          
          /*let photo = temp_photos.pop(0)
          if (row_size + photo > 8) {
            to_next_row.push(photo)
          } else {
            if (photo == 1) {
              //row_p += 1
              row_size += 1
            } else if (photo == 2.25) {
              //row_l += 1
              row_size += 2.25
            }
            row.push(photo)
          }

          temp_photos = to_next_row.concat(temp_photos)*/
        }

        //temp_photos = temp_photos.concat(to_next_row)
        //let landscape = 'landscape-2P-2L'
        let classLandscape = { 'ma-1': true }
        classLandscape['landscape-' + row_p + 'P-' + row_l + 'L'] = true
        let classPortrait = { 'ma-1': true }
        classPortrait['portrait-' + row_p + 'P-' + row_l + 'L'] = true
        rows.push({ id: rows.length, photos: row, classLandscape: classLandscape, classPortrait: classPortrait})
      }
      return rows;
      //return [
        //{ id: 1, photos: [2.25, 2.25, 1, 1], classLandscape: { 'ma-1': true, 'landscape-2P-2L': true }, classPortrait: { 'ma-1': true, 'portrait-2P-2L': true } },
        //{ id: 2, photos: [2.25, 2.25, 1, 1], classLandscape: { 'ma-1': true, 'landscape-2P-2L': true }, classPortrait: { 'ma-1': true, 'portrait-2P-2L': true } },
      //]
    },
    
},    methods: {
      openDialog(photo) {
        this.dialog = true
        this.selectedPhoto = photo
      },
      onKeydown(event) {
        if (this.dialog) {
          if (event.key == 'Escape') {
            this.closeDialog()
          } else if (event.key == "ArrowRight") {
            this.nextPhoto()
          } else if (event.key == "ArrowLeft") {
            this.previousPhoto()
          }
        }
      },
      closeDialog() {
        this.dialog = false
        this.selectedPhoto = 0
      },
      nextPhoto() {
        for (var i = 0; i < this.galleryRows.length; i++) {
          for (var j = 0; j < this.galleryRows[i].photos.length; j++) {
            if (this.selectedPhoto.id == this.galleryRows[i].photos[j].id) {
              if (j == this.galleryRows[i].photos.length - 1 && i < this.galleryRows.length - 1) {
                this.selectedPhoto = this.photos.filter(e => e.id == this.galleryRows[i + 1].photos[0].id)[0]
                return
              } else if (j < this.galleryRows[i].photos.length - 1) {
                this.selectedPhoto = this.photos.filter(e => e.id == this.galleryRows[i].photos[j + 1].id)[0]
                return 
              }
            }
          }
        }
      },
      previousPhoto() {
        for (var i = 0; i < this.galleryRows.length; i++) {
          for (var j = 0; j < this.galleryRows[i].photos.length; j++) {
            if (this.selectedPhoto.id == this.galleryRows[i].photos[j].id) {
              if (j == 0 && i > 0) {
                this.selectedPhoto = this.photos.filter(e => e.id == this.galleryRows[i - 1].photos[0].id)[0]
                return
              } else if (j > 0) {
                this.selectedPhoto = this.photos.filter(e => e.id == this.galleryRows[i].photos[j - 1].id)[0]
                return 
              }
            }
          }
        }
      },
      async loadGallery() {
        this.$store.state.loading = true;
        try {
          const { data } = await this.$http.get(this.$urls['api:gallery_detail'](), {
            params: { 'thon_year': this.thon_year, 'slug': this.slug }
          })
          this.gallery = data
          this.$store.state.loading = false;
          if (this.gallery.id) {
            await this.loadPhotos();
          } else {
            this.$store.commit('showAlert', { message: `Gallery not found.`, status: 'warning' })
            this.$store.state.loading = false;
          }
        } catch (e) {
          this.$store.commit('showAlert', { message: `Unknown error: ${e}`, status: 'error' })
          this.$store.state.loading = false;
        }
      },
      async loadPhotos() {
        if (!this.$store.state.loading && this.pagesLoaded < this.gallery.page_count) {
          this.$store.state.loading = true;
          try {
            const { data } = await this.$http.get(this.$urls['api:photos_list'](), {
              params: { 'gallery_id': this.gallery.id, 'page': this.pagesLoaded + 1, 'limit': 75 }
            })
            this.pagesLoaded += 1;
            this.photos = data.concat(this.photos);
            this.$store.state.loading = false;
          } catch (e) {
            this.$store.commit('showAlert', { message: `Unknown error: ${e}`, status: 'error' })
            this.$store.state.loading = false;
          }
        }
      },
      photoWidthRatio(photo) {
        let aspect = photo.image_width / photo.image_height
        if (aspect == 2 / 3) {
          return 1
        } else if (aspect == 3 / 2) {
          return 2.25
        }
        if (aspect < 1) {
          return 1
        } else if (aspect >= 1) {
          return 2.25
        }
      }
    },
    async mounted() {
      await this.loadGallery();
      window.addEventListener('keydown', this.onKeydown)
      var lastScroll = 0;
      var photosFn = this.loadPhotos;
      window.onscroll = async function() {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        // Check if scrolling down
        if (currentScroll > 0 && lastScroll <= currentScroll){
          lastScroll = currentScroll;
          // Check if we are at div element referenced by "galleryEnd"
          if (document.getElementById('galleryEnd').getBoundingClientRect().top <= window.innerHeight) {
            console.log("Loading more photos...")
            await photosFn();
          }
        } else{
          lastScroll = currentScroll;
        }
      };
    }
}
</script>


<style>
.landscape-1P-0L {
    width: calc(((100% - 8px) / 1) * 2.25)
}

.portrait-1P-0L {
    width: calc(((100% - 8px) / 1) * 1)
}

.landscape-0P-1L {
    width: calc(((100% - 8px) / 2.25) * 2.25)
}

.portrait-0P-1L {
    width: calc(((100% - 8px) / 2.25) * 1)
}

.landscape-2P-0L {
    width: calc(((100% - 16px) / 2) * 2.25)
}

.portrait-2P-0L {
    width: calc(((100% - 16px) / 2) * 1)
}

.landscape-1P-1L {
    width: calc(((100% - 16px) / 3.25) * 2.25)
}

.portrait-1P-1L {
    width: calc(((100% - 16px) / 3.25) * 1)
}

.landscape-0P-2L {
    width: calc(((100% - 16px) / 4.5) * 2.25)
}

.portrait-0P-2L {
    width: calc(((100% - 16px) / 4.5) * 1)
}

.landscape-3P-0L {
    width: calc(((100% - 24px) / 3) * 2.25)
}

.portrait-3P-0L {
    width: calc(((100% - 24px) / 3) * 1)
}

.landscape-2P-1L {
    width: calc(((100% - 24px) / 4.25) * 2.25)
}

.portrait-2P-1L {
    width: calc(((100% - 24px) / 4.25) * 1)
}

.landscape-1P-2L {
    width: calc(((100% - 24px) / 5.5) * 2.25)
}

.portrait-1P-2L {
    width: calc(((100% - 24px) / 5.5) * 1)
}

.landscape-0P-3L {
    width: calc(((100% - 24px) / 6.75) * 2.25)
}

.portrait-0P-3L {
    width: calc(((100% - 24px) / 6.75) * 1)
}

.landscape-4P-0L {
    width: calc(((100% - 32px) / 4) * 2.25)
}

.portrait-4P-0L {
    width: calc(((100% - 32px) / 4) * 1)
}

.landscape-3P-1L {
    width: calc(((100% - 32px) / 5.25) * 2.25)
}

.portrait-3P-1L {
    width: calc(((100% - 32px) / 5.25) * 1)
}

.landscape-2P-2L {
    width: calc(((100% - 32px) / 6.5) * 2.25)
}

.portrait-2P-2L {
    width: calc(((100% - 32px) / 6.5) * 1)
}

.landscape-1P-3L {
    width: calc(((100% - 32px) / 7.75) * 2.25)
}

.portrait-1P-3L {
    width: calc(((100% - 32px) / 7.75) * 1)
}

.landscape-0P-4L {
    width: calc(((100% - 32px) / 9.0) * 2.25)
}

.portrait-0P-4L {
    width: calc(((100% - 32px) / 9.0) * 1)
}

.landscape-5P-0L {
    width: calc(((100% - 40px) / 5) * 2.25)
}

.portrait-5P-0L {
    width: calc(((100% - 40px) / 5) * 1)
}

.landscape-4P-1L {
    width: calc(((100% - 40px) / 6.25) * 2.25)
}

.portrait-4P-1L {
    width: calc(((100% - 40px) / 6.25) * 1)
}

.landscape-3P-2L {
    width: calc(((100% - 40px) / 7.5) * 2.25)
}

.portrait-3P-2L {
    width: calc(((100% - 40px) / 7.5) * 1)
}

.landscape-2P-3L {
    width: calc(((100% - 40px) / 8.75) * 2.25)
}

.portrait-2P-3L {
    width: calc(((100% - 40px) / 8.75) * 1)
}

.landscape-1P-4L {
    width: calc(((100% - 40px) / 10.0) * 2.25)
}

.portrait-1P-4L {
    width: calc(((100% - 40px) / 10.0) * 1)
}

.landscape-0P-5L {
    width: calc(((100% - 40px) / 11.25) * 2.25)
}

.portrait-0P-5L {
    width: calc(((100% - 40px) / 11.25) * 1)
}

.landscape-6P-0L {
    width: calc(((100% - 48px) / 6) * 2.25)
}

.portrait-6P-0L {
    width: calc(((100% - 48px) / 6) * 1)
}

.landscape-5P-1L {
    width: calc(((100% - 48px) / 7.25) * 2.25)
}

.portrait-5P-1L {
    width: calc(((100% - 48px) / 7.25) * 1)
}

.landscape-4P-2L {
    width: calc(((100% - 48px) / 8.5) * 2.25)
}

.portrait-4P-2L {
    width: calc(((100% - 48px) / 8.5) * 1)
}

.landscape-3P-3L {
    width: calc(((100% - 48px) / 9.75) * 2.25)
}

.portrait-3P-3L {
    width: calc(((100% - 48px) / 9.75) * 1)
}

.landscape-2P-4L {
    width: calc(((100% - 48px) / 11.0) * 2.25)
}

.portrait-2P-4L {
    width: calc(((100% - 48px) / 11.0) * 1)
}

.landscape-1P-5L {
    width: calc(((100% - 48px) / 12.25) * 2.25)
}

.portrait-1P-5L {
    width: calc(((100% - 48px) / 12.25) * 1)
}

.landscape-0P-6L {
    width: calc(((100% - 48px) / 13.5) * 2.25)
}

.portrait-0P-6L {
    width: calc(((100% - 48px) / 13.5) * 1)
}

.landscape-7P-0L {
    width: calc(((100% - 56px) / 7) * 2.25)
}

.portrait-7P-0L {
    width: calc(((100% - 56px) / 7) * 1)
}

.landscape-6P-1L {
    width: calc(((100% - 56px) / 8.25) * 2.25)
}

.portrait-6P-1L {
    width: calc(((100% - 56px) / 8.25) * 1)
}

.landscape-5P-2L {
    width: calc(((100% - 56px) / 9.5) * 2.25)
}

.portrait-5P-2L {
    width: calc(((100% - 56px) / 9.5) * 1)
}

.landscape-4P-3L {
    width: calc(((100% - 56px) / 10.75) * 2.25)
}

.portrait-4P-3L {
    width: calc(((100% - 56px) / 10.75) * 1)
}

.landscape-3P-4L {
    width: calc(((100% - 56px) / 12.0) * 2.25)
}

.portrait-3P-4L {
    width: calc(((100% - 56px) / 12.0) * 1)
}

.landscape-2P-5L {
    width: calc(((100% - 56px) / 13.25) * 2.25)
}

.portrait-2P-5L {
    width: calc(((100% - 56px) / 13.25) * 1)
}

.landscape-1P-6L {
    width: calc(((100% - 56px) / 14.5) * 2.25)
}

.portrait-1P-6L {
    width: calc(((100% - 56px) / 14.5) * 1)
}

.landscape-0P-7L {
    width: calc(((100% - 56px) / 15.75) * 2.25)
}

.portrait-0P-7L {
    width: calc(((100% - 56px) / 15.75) * 1)
}

.landscape-8P-0L {
    width: calc(((100% - 64px) / 8) * 2.25)
}

.portrait-8P-0L {
    width: calc(((100% - 64px) / 8) * 1)
}

.landscape-7P-1L {
    width: calc(((100% - 64px) / 9.25) * 2.25)
}

.portrait-7P-1L {
    width: calc(((100% - 64px) / 9.25) * 1)
}

.landscape-6P-2L {
    width: calc(((100% - 64px) / 10.5) * 2.25)
}

.portrait-6P-2L {
    width: calc(((100% - 64px) / 10.5) * 1)
}

.landscape-5P-3L {
    width: calc(((100% - 64px) / 11.75) * 2.25)
}

.portrait-5P-3L {
    width: calc(((100% - 64px) / 11.75) * 1)
}

.landscape-4P-4L {
    width: calc(((100% - 64px) / 13.0) * 2.25)
}

.portrait-4P-4L {
    width: calc(((100% - 64px) / 13.0) * 1)
}

.landscape-3P-5L {
    width: calc(((100% - 64px) / 14.25) * 2.25)
}

.portrait-3P-5L {
    width: calc(((100% - 64px) / 14.25) * 1)
}

.landscape-2P-6L {
    width: calc(((100% - 64px) / 15.5) * 2.25)
}

.portrait-2P-6L {
    width: calc(((100% - 64px) / 15.5) * 1)
}

.landscape-1P-7L {
    width: calc(((100% - 64px) / 16.75) * 2.25)
}

.portrait-1P-7L {
    width: calc(((100% - 64px) / 16.75) * 1)
}

.landscape-0P-8L {
    width: calc(((100% - 64px) / 18.0) * 2.25)
}

.portrait-0P-8L {
    width: calc(((100% - 64px) / 18.0) * 1)
}

.landscape-9P-0L {
    width: calc(((100% - 72px) / 9) * 2.25)
}

.portrait-9P-0L {
    width: calc(((100% - 72px) / 9) * 1)
}

.landscape-8P-1L {
    width: calc(((100% - 72px) / 10.25) * 2.25)
}

.portrait-8P-1L {
    width: calc(((100% - 72px) / 10.25) * 1)
}

.landscape-7P-2L {
    width: calc(((100% - 72px) / 11.5) * 2.25)
}

.portrait-7P-2L {
    width: calc(((100% - 72px) / 11.5) * 1)
}

.landscape-6P-3L {
    width: calc(((100% - 72px) / 12.75) * 2.25)
}

.portrait-6P-3L {
    width: calc(((100% - 72px) / 12.75) * 1)
}

.landscape-5P-4L {
    width: calc(((100% - 72px) / 14.0) * 2.25)
}

.portrait-5P-4L {
    width: calc(((100% - 72px) / 14.0) * 1)
}

.landscape-4P-5L {
    width: calc(((100% - 72px) / 15.25) * 2.25)
}

.portrait-4P-5L {
    width: calc(((100% - 72px) / 15.25) * 1)
}

.landscape-3P-6L {
    width: calc(((100% - 72px) / 16.5) * 2.25)
}

.portrait-3P-6L {
    width: calc(((100% - 72px) / 16.5) * 1)
}

.landscape-2P-7L {
    width: calc(((100% - 72px) / 17.75) * 2.25)
}

.portrait-2P-7L {
    width: calc(((100% - 72px) / 17.75) * 1)
}

.landscape-1P-8L {
    width: calc(((100% - 72px) / 19.0) * 2.25)
}

.portrait-1P-8L {
    width: calc(((100% - 72px) / 19.0) * 1)
}

.landscape-0P-9L {
    width: calc(((100% - 72px) / 20.25) * 2.25)
}

.portrait-0P-9L {
    width: calc(((100% - 72px) / 20.25) * 1)
}

.landscape-10P-0L {
    width: calc(((100% - 80px) / 10) * 2.25)
}

.portrait-10P-0L {
    width: calc(((100% - 80px) / 10) * 1)
}

.landscape-9P-1L {
    width: calc(((100% - 80px) / 11.25) * 2.25)
}

.portrait-9P-1L {
    width: calc(((100% - 80px) / 11.25) * 1)
}

.landscape-8P-2L {
    width: calc(((100% - 80px) / 12.5) * 2.25)
}

.portrait-8P-2L {
    width: calc(((100% - 80px) / 12.5) * 1)
}

.landscape-7P-3L {
    width: calc(((100% - 80px) / 13.75) * 2.25)
}

.portrait-7P-3L {
    width: calc(((100% - 80px) / 13.75) * 1)
}

.landscape-6P-4L {
    width: calc(((100% - 80px) / 15.0) * 2.25)
}

.portrait-6P-4L {
    width: calc(((100% - 80px) / 15.0) * 1)
}

.landscape-5P-5L {
    width: calc(((100% - 80px) / 16.25) * 2.25)
}

.portrait-5P-5L {
    width: calc(((100% - 80px) / 16.25) * 1)
}

.landscape-4P-6L {
    width: calc(((100% - 80px) / 17.5) * 2.25)
}

.portrait-4P-6L {
    width: calc(((100% - 80px) / 17.5) * 1)
}

.landscape-3P-7L {
    width: calc(((100% - 80px) / 18.75) * 2.25)
}

.portrait-3P-7L {
    width: calc(((100% - 80px) / 18.75) * 1)
}

.landscape-2P-8L {
    width: calc(((100% - 80px) / 20.0) * 2.25)
}

.portrait-2P-8L {
    width: calc(((100% - 80px) / 20.0) * 1)
}

.landscape-1P-9L {
    width: calc(((100% - 80px) / 21.25) * 2.25)
}

.portrait-1P-9L {
    width: calc(((100% - 80px) / 21.25) * 1)
}

.landscape-0P-10L {
    width: calc(((100% - 80px) / 22.5) * 2.25)
}

.portrait-0P-10L {
    width: calc(((100% - 80px) / 22.5) * 1)
}
</style>